exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-icon-social {\n  width: 30px;\n  height: 30px;\n  margin-left: 14px; }\n\n.social-icons-footer {\n  margin-bottom: 10px; }\n", ""]);

// exports
